module.exports = __webpack_public_path__ + "static/osc-logo-87358eda8b5a2e505510730f9554626b.png";